module.exports = __webpack_public_path__ + "img/voucher-bg.da843f42.svg";